const pathSeparator = '.'
function setProperty(root, propertyChain, value){
    const props = propertyChain.split(pathSeparator)
    for (let i = 0; i < props.length-1; i++) {
        root = root[props[i]]
        if(!root){
            break
        }
    }
    if(root){
        root[props[props.length-1]] = value
        return true
    }
    return false
}
// 获取当前path值
function getProperty(obj, path, leftDeviation = 0) {
    const pathArr = path.split(pathSeparator);

    for (let i = 0; i < pathArr.length - leftDeviation; i += 1) {
        // 错误路径或者undefined中断查找
        if (obj === undefined) return undefined;
        obj = pathArr[i] === '' ? obj : obj[pathArr[i]];
    }
    return obj;
}
function deepClone(obj, deep){
    if(obj){
        return JSON.parse(JSON.stringify(obj)); 
    }    
}
const deepProxyHandler = {
    get ({target,path,handler,innerPropProxy}, property) {
        if(handler.get){
            return handler.get(target, property,{path})
        }else if(target){

            const v = target[property]
            if(v && property[0]!=='_' && property.indexOf('__v_')==-1 && typeof v=='object'){
                if(innerPropProxy[property]){
                    return innerPropProxy[property]
                }else{
                    let propPath = property
                    if(path){
                        propPath = path +'.'+propPath
                    }
                    
                    const propProxy = deepProxy(v, handler, propPath)
                    innerPropProxy[property] = propProxy
                    return propProxy
                }
                 
            }else{
                return v
            }
        }
    },
    set ({target, path, handler}, property, value) {
        
        if(handler.set){
            return handler.set(target, property, value, {path})
        }else {
            target[property] = value
            return true
        }
    },
    ownKeys({target}){
        return Object.keys(target)
    },
    has({target}, prop){
        return Object.has(target,prop)
    },
    deleteProperty({target}, prop){
        delete target[prop]
    }
}
function deepProxy(target, handler, path){
    const innerPropProxy = {}
    return new Proxy({target, path, handler, innerPropProxy}, deepProxyHandler)
    

}
export {setProperty, getProperty, deepClone, deepProxy}